/* MAIYKO EKLENTI — Video Vitrin
   Yatay dikey-video kartları + yüzen oynatıcı paneli.
   Bağımsız IIFE, jQuery yok, Safari 15+ uyumlu.
   Bu dosya SADECE "Video Vitrin (Maiyko)" block'u render olduğunda yüklenir.

   KART ÖNİZLEMELERİ (kendiliğinden oynayan sessiz döngü)
   ---------------------------------------------------------------------------
   - İKİ ayrı IntersectionObserver kullanılır. Tek observer'a rootMargin
     verilince intersectionRatio genişletilmiş dikdörtgene göre hesaplandığı
     için "ekranda değil ama %100 görünür" gibi yanlış sonuç çıkar:
       ioYukle : rootMargin 200px, esik 0    -> <source> ekle (bir kez)
       ioOyna  : rootMargin yok,   esik 0.35 -> oynat / duraklat
   - video.muted ÖZNİTELİK olarak yetmez; Safari'de otomatik oynatmanın
     çalışması için property olarak da set edilmelidir (play() öncesi).
   - play() bir promise döndürür ve tarayıcı reddedebilir (güç tasarrufu,
     veri tasarrufu modu). Reddi sessizce yutarız: poster görünür kalır.
   - prefers-reduced-motion: reduce -> hiç yükleme ve oynatma yapılmaz.
   - Yüzen oynatıcı açıkken TÜM önizlemeler duraklatılır (tek ses/işlemci
     kaynağı oynatıcının olsun); kapanınca görünür olanlar devam eder.

   ARKA PLAN KAYDIRMA KİLİDİ
   ---------------------------------------------------------------------------
   - Oynatıcı açıkken <html>'e maiyko-vv-kilit sınıfı eklenir (mobilde tam
     ekran panelin arkasında sayfa kaymasın diye).
   - Sayaç MODÜL seviyesindedir: aynı sayfada birden çok blok olsa bile
     sonuncusu kapanmadan sınıf kaldırılmaz. Her root kendi kilidini bir kez
     alır (kilitliyiz bayrağı), böylece sayaç asla kaymaz. */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-maiyko-video-vitrin]';
  var READY_FLAG = 'maiykoVvReady';
  var KILIT_SINIF = 'maiyko-vv-kilit';
  var YUKLE_MARGIN = '200px 0px';
  var OYNAT_ESIGI = 0.35;

  /* Sayfadaki TÜM bloklar için ortak kilit sayacı. */
  var kilitSayaci = 0;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function azHareket() {
    try {
      return !!(
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    } catch (e) {
      return false;
    }
  }

  /* Oynatıcı body'ye taşınınca (bkz. PORTAL) blok kökünden KALITIMLA inen
     CSS değişkenlerini kaybeder. Panelin çerçevesi/köşesi bu değişkenlere
     bağlı olduğu için taşımadan önce panelin kendi stiline kopyalanır.
     Tanımsız bir var() "geçersiz" sayılır: çerçeve currentColor'a, köşe 0'a
     düşerdi — yani sessiz bir görsel bozulma olurdu. */
  var TASINACAK_DEGISKENLER = ['--mvv-h', '--mvv-radius', '--mvv-border'];

  function hesaplananDeger(el, ad) {
    try {
      if (typeof window.getComputedStyle !== 'function') return '';
      var cs = window.getComputedStyle(el);
      if (!cs || typeof cs.getPropertyValue !== 'function') return '';
      return cs.getPropertyValue(ad) || '';
    } catch (e) {
      return '';
    }
  }

  function degiskenleriKopyala(kaynak, hedef) {
    if (!kaynak || !kaynak.style || !hedef || !hedef.style) return;
    if (typeof hedef.style.setProperty !== 'function') return;

    for (var i = 0; i < TASINACAK_DEGISKENLER.length; i++) {
      var ad = TASINACAK_DEGISKENLER[i];
      var deger = '';
      /* Snippet bunları inline basar; inline yoksa hesaplanana düşülür. */
      if (typeof kaynak.style.getPropertyValue === 'function') {
        deger = kaynak.style.getPropertyValue(ad);
      }
      if (typeof deger !== 'string' || deger === '') deger = hesaplananDeger(kaynak, ad);
      if (typeof deger !== 'string') continue;
      deger = deger.replace(/^\s+|\s+$/g, '');
      if (deger === '') continue;
      try {
        hedef.style.setProperty(ad, deger);
      } catch (e) {
        /* yoksay */
      }
    }
  }

  /* Tema editörü section'ı yeniden render edince ESKİ portallanmış oynatıcı
     body'de öksüz kalır (taze render kendi düğümünü getirir). Aynı kimlikli
     bayat düğümü söker. document.getElementById BELGE SIRASINA göre taze
     düğümü döndürebileceği için doğrudan body'nin çocukları taranır —
     portallanan düğümler zaten yalnızca oraya eklenir. */
  function eskiPortaliKaldir(kimlik, taze) {
    if (!kimlik || !document.body) return;
    var cocuklar = document.body.children;
    if (!cocuklar) return;

    for (var i = cocuklar.length - 1; i >= 0; i--) {
      var c = cocuklar[i];
      if (!c || c === taze) continue;
      if (typeof c.getAttribute !== 'function') continue;
      if (c.getAttribute('id') !== kimlik) continue;
      if (!c.parentNode) continue;
      try {
        c.parentNode.removeChild(c);
      } catch (e) {
        /* yoksay */
      }
    }
  }

  function initRoot(root) {
    if (!root || root.dataset[READY_FLAG] === '1') return;

    var cards = toArray(root.querySelectorAll('[data-mvv-card]'));
    var player = root.querySelector('[data-mvv-player]');
    var video = player ? player.querySelector('[data-mvv-video]') : null;
    if (!cards.length || !player || !video) return;

    root.dataset[READY_FLAG] = '1';

    /* ---- PORTAL: oynatıcıyı doğrudan <body>'ye taşı ----
       Panel ve karartma position:fixed'tir. fixed konum, ancak ataların
       HİÇBİRİNDE transform/filter/perspective yoksa ekrana (viewport) göre
       çözülür; böyle bir ata varsa o ata yeni bir "içeren blok" olur ve fixed
       ona göre konumlanır. Bu temanın ürün sayfası kolon elemanlarında
       transform bulunuyor: oynatıcı blok içinde kalırsa panel ekranın ortası
       yerine bloğun yanında çıkıyor, karartma tüm ekranı kaplamıyor, kapat
       düğmesi ekran dışına düşüp panel kapatılamıyor; mobilde inset:0 "tam
       ekran" da yanlış yere oturuyor. Kısıt CSS'ten okunamaz (sorun temanın
       KENDİ stilinde), tek güvenli çözüm düğümü transform'lu zincirin DIŞINA
       almaktır. Aynı desen mini kuponda da kullanıldı.

       Taşıma listener'lardan ÖNCE yapılır ama davranışı etkilemez: taşınan
       düğümün üzerindeki/altındaki listener'lar taşımada korunur, aşağıdaki
       tüm sorgular da player değişkeni üzerinden yürür. */
    var portalKimlik = player.getAttribute('id') || '';
    var portallandi = false;

    if (document.body && typeof document.body.appendChild === 'function') {
      degiskenleriKopyala(root, player);
      eskiPortaliKaldir(portalKimlik, player);
      if (player.parentNode === document.body) {
        portallandi = true;
      } else {
        try {
          document.body.appendChild(player);
          portallandi = true;
        } catch (e) {
          /* Taşınamadıysa yerinde kalsın: eski (hatalı konumlu) hâl sürer,
             ama blok tamamen çalışmaz duruma düşmez. */
        }
      }
    }

    var current = -1;

    /* ---- Kart önizlemeleri ---- */

    var thumbs = cards.map(function (card) {
      return card.querySelector('[data-mvv-thumb]');
    });
    var gorunur = cards.map(function () {
      return false;
    });
    var sessiz = azHareket();
    var ioYukle = null;
    var ioOyna = null;

    function kaynakYukle(i) {
      var v = thumbs[i];
      if (!v || v.getAttribute('data-mvv-yuklu') === '1') return;
      /* Önizleme kaynağı yoksa oynatıcının kaynağına düşülür. */
      var src =
        cards[i].getAttribute('data-mvv-preview') || cards[i].getAttribute('data-mvv-src');
      if (!src) return;

      v.setAttribute('data-mvv-yuklu', '1');
      var source = document.createElement('source');
      source.setAttribute('src', src);
      source.setAttribute('type', 'video/mp4');
      v.appendChild(source);
      try {
        v.load();
      } catch (e) {
        /* yoksay */
      }
    }

    function onizlemeOynat(i) {
      var v = thumbs[i];
      if (!v || sessiz) return;
      if (!player.hidden) return; /* oynatıcı açıkken kartlar susar */
      kaynakYukle(i);
      /* Safari: öznitelik yetmiyor, property olarak da sessize alınmalı. */
      v.muted = true;
      var played;
      try {
        played = v.play();
      } catch (e) {
        return;
      }
      if (played && typeof played.catch === 'function') {
        played.catch(function () {
          /* Tarayıcı reddetti: poster görünür kalır, sorun değil. */
        });
      }
    }

    function onizlemeDurdur(i) {
      var v = thumbs[i];
      if (!v) return;
      try {
        v.pause();
      } catch (e) {
        /* yoksay */
      }
    }

    function tumOnizlemeleriDurdur() {
      for (var i = 0; i < thumbs.length; i++) {
        onizlemeDurdur(i);
      }
    }

    function gorunurleriOynat() {
      for (var i = 0; i < thumbs.length; i++) {
        if (gorunur[i]) onizlemeOynat(i);
      }
    }

    function onizlemeleriKur() {
      if (sessiz) return; /* reduced-motion: yükleme de oynatma da yok */

      var varmi = false;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i]) varmi = true;
      }
      if (!varmi) return;

      /* IntersectionObserver yoksa (çok eski tarayıcı): hepsini yükleyip
         oynatmayı dene; reddedilirse poster kalır. */
      if (typeof window.IntersectionObserver !== 'function') {
        for (var j = 0; j < thumbs.length; j++) {
          gorunur[j] = true;
          onizlemeOynat(j);
        }
        return;
      }

      ioYukle = new window.IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var i = thumbs.indexOf(entry.target);
            if (i < 0) return;
            kaynakYukle(i);
            ioYukle.unobserve(entry.target); /* bir kez yeter */
          });
        },
        { rootMargin: YUKLE_MARGIN, threshold: 0 }
      );

      ioOyna = new window.IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var i = thumbs.indexOf(entry.target);
            if (i < 0) return;
            var yeterli = entry.isIntersecting && entry.intersectionRatio >= OYNAT_ESIGI;
            gorunur[i] = yeterli;
            if (yeterli) onizlemeOynat(i);
            else onizlemeDurdur(i);
          });
        },
        { threshold: [0, OYNAT_ESIGI] }
      );

      thumbs.forEach(function (v) {
        if (!v) return;
        ioYukle.observe(v);
        ioOyna.observe(v);
      });
    }

    function gozlemleriBirak() {
      if (ioYukle) {
        try {
          ioYukle.disconnect();
        } catch (e) {
          /* yoksay */
        }
        ioYukle = null;
      }
      if (ioOyna) {
        try {
          ioOyna.disconnect();
        } catch (e) {
          /* yoksay */
        }
        ioOyna = null;
      }
    }

    /* ---- Arka plan kaydırma kilidi ---- */

    var kilitliyiz = false;

    function kilitle() {
      if (kilitliyiz) return;
      kilitliyiz = true;
      kilitSayaci++;
      var kok = document.documentElement;
      if (kok && kok.classList) kok.classList.add(KILIT_SINIF);
    }

    function kilidiAc() {
      if (!kilitliyiz) return;
      kilitliyiz = false;
      if (kilitSayaci > 0) kilitSayaci--;
      if (kilitSayaci > 0) return; /* başka blok hâlâ açık */
      var kok = document.documentElement;
      if (kok && kok.classList) kok.classList.remove(KILIT_SINIF);
    }

    /* Kaynağı tamamen söker: panel kapandığında ses/indirme devam etmesin. */
    function unload() {
      try {
        video.pause();
      } catch (e) {
        /* yoksay */
      }
      while (video.firstChild) {
        video.removeChild(video.firstChild);
      }
      video.removeAttribute('src');
      video.removeAttribute('poster');
      try {
        video.load();
      } catch (e) {
        /* yoksay */
      }
    }

    function open(index) {
      if (!cards.length) return;
      var i = index;
      if (i < 0) i = cards.length - 1;
      if (i >= cards.length) i = 0;

      var card = cards[i];
      var src = card.getAttribute('data-mvv-src');
      if (!src) return;

      var poster = card.getAttribute('data-mvv-poster');

      unload();
      current = i;

      if (poster) video.setAttribute('poster', poster);

      var source = document.createElement('source');
      source.setAttribute('src', src);
      source.setAttribute('type', 'video/mp4');
      video.appendChild(source);

      try {
        video.load();
      } catch (e) {
        /* yoksay */
      }

      player.hidden = false;
      root.classList.add('maiyko-vv--open');
      tumOnizlemeleriDurdur();
      kilitle();

      /* Kullanıcı tıklamasıyla açıldığı için sesli oynatma engellenmez;
         yine de tarayıcı reddederse sessizce yut. */
      var played = video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(function () {
          /* yoksay */
        });
      }

      var closeBtn = player.querySelector('[data-mvv-close]:not(.maiyko-vv__backdrop)');
      if (closeBtn && typeof closeBtn.focus === 'function') {
        closeBtn.focus();
      }
    }

    function close() {
      if (player.hidden) return;
      unload();
      player.hidden = true;
      root.classList.remove('maiyko-vv--open');
      kilidiAc();
      gorunurleriOynat();
      var last = cards[current];
      current = -1;
      if (last && typeof last.focus === 'function') {
        last.focus();
      }
    }

    function step(delta) {
      if (current < 0) return;
      open(current + delta);
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        open(i);
      });
    });

    toArray(player.querySelectorAll('[data-mvv-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });

    var prev = player.querySelector('[data-mvv-prev]');
    if (prev) {
      prev.addEventListener('click', function () {
        step(-1);
      });
    }

    var next = player.querySelector('[data-mvv-next]');
    if (next) {
      next.addEventListener('click', function () {
        step(1);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (player.hidden) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc') {
        e.preventDefault();
        close();
      } else if (k === 'ArrowUp') {
        e.preventDefault();
        step(-1);
      } else if (k === 'ArrowDown') {
        e.preventDefault();
        step(1);
      }
    });

    /* Tema editöründe blok kaldırılırsa artakalan panel/ses/kilit bırakma. */
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains && e.target.contains(root)) {
        unload();
        tumOnizlemeleriDurdur();
        gozlemleriBirak();
        kilidiAc();
        /* PORTAL edilen oynatıcı artık section'ın ALTINDA değil, body'nin
           çocuğudur: section silinince onunla gitmez, elle sökülmelidir. */
        if (portallandi && player.parentNode) {
          try {
            player.parentNode.removeChild(player);
          } catch (e2) {
            /* yoksay */
          }
          portallandi = false;
        }
      }
    });

    onizlemeleriKur();
  }

  function boot(scope) {
    var node = scope && scope.querySelectorAll ? scope : document;
    toArray(node.querySelectorAll(ROOT_SELECTOR)).forEach(initRoot);
    if (node !== document && node.matches && node.matches(ROOT_SELECTOR)) {
      initRoot(node);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  /* Tema editörü: blok/section yeniden yüklendiğinde tekrar bağla. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();
